export default __webpack_public_path__ + "static/media/ALLERGEN_CELERY.d823167f.png";